<template>
  <div class="header">
    <header>
      <div class="content">
        <span class="logo">App服务配置中心</span>
        <nav class="mune">
          <router-link :to="{ name: 'supervise'}">服务中心</router-link>
          <router-link :to="{ name: 'appversion'}">App版本</router-link>
          <!-- <router-link :to="{ name: 'pluginManage'}">插件管理</router-link> -->
<!--          <router-link :to="{ name: 'objStorage'}">对象存储</router-link>-->
        </nav>
        <el-dropdown class="account">
          <span class="el-dropdown-link">
            <el-avatar>
              {{ msg?msg.userName:'user' }}
            </el-avatar>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </header>
  </div>
</template>

<script setup>
  // export default {
  //   name: 'VHeader',
  //   data() {
  //     return {};
  //   }
  // };

  import {ref, reactive, onMounted, onUnmounted, getCurrentInstance} from 'vue';

  const { proxy } = getCurrentInstance();
  const msg = reactive({
    userName: '',
  });


  const logout  = () =>{
    document.cookie = ''
    localStorage.clear();
    proxy.$router.push('/login');
  }

  onMounted(() => {
    let state = proxy.$store.state;
    let user = state.user;
    if(user){
      msg.userName = user.userName;
    }
  });
  onUnmounted(() => {

  })

</script>


<style scoped lang="scss">
  .content {
    width: 80%;
    display: inline-block;
    text-align: left;
    .logo {
      line-height: 60px;
      font-size: 20px;
      color: #fff;
      display: inline-block;
      margin: 0 16px;
    }
    .mune {
      position: absolute;
      right: 100px;
      display: inline-block;
      text-align: right;
      a {
        padding: 0 10px;
        font-size: 16px;
        display: inline-block;
        height: 58px;
        line-height: 80px;
        color: #fff;
        text-decoration: none;
      }
      a:hover {
        border-bottom: 2px #fff solid;
      }
    }

    .account{
      position: absolute;
      right: 0;
      margin: 10px 16px;
      cursor: pointer;
    }
  }
</style>